// Simple array you can keep adding to.
export type MediaItem = {
  title: string;
  source?: string;
  url: string;
  date?: string; // ISO like "2025-09-20"
};

export const MEDIA_LINKS: MediaItem[] = [

  {
    title: "EIT Food unveils 2026 accelerator cohort to advance agri-food technologies",
    source: "Food Ingredients First",
    url: "https://www.foodingredientsfirst.com/news/eit-food-accelerates-agri-food-startups.html",
    date: "2026-06-30",
  },

  {
    title: "EIT Food backs 65 start-ups in 2026 FAN programme to fast-track agri-food innovation",
    source: "AgNavigator",
    url: "https://www.agnavigator.com/Article/2026/06/29/eit-food-backs-65-start-ups-in-2026-fan-programme-to-fast-track-agri-food-innovation/",
    date: "2026-06-29",
  },

  {
    title: "Scindo Secures £4 Million Investment to Advance AI-Driven Enzyme Engineering",
    source: "SynBioBeta",
    url: "https://www.synbiobeta.com/read/scindo-secures-ps4-million-investment-to-advance-ai-driven-enzyme-engineering",
    date: "2025-10-02",
  },
  
       {
    title: "Deras AI kan skapa rosdoft utan rosor – tar in kapital från Pinc",
    source: "ImpactLoop",
    url: "https://www.impactloop.se/artikel/deras-ai-kan-skapa-rosdoft-utan-rosor-tar-in-kapital-fran-pinc", // include scheme
    date: "2025-09-24",
  },
  {
    title: "Scindo raises $5.4m seed round for AI-powered enzyme discovery platform",
    source: "AgFunder News",
    url: "https://agfundernews.com/scindo-raises-5-4m-seed-round-for-ai-powered-enzyme-discovery-platform", // include scheme
    date: "2025-09-23",
  },
   
  {
    title: "London’s Scindo raises €4.5 million to accelerate sustainable ingredients platform",
    source: "EU Start-ups",
    url: "https://www.eu-startups.com/2025/09/londons-scindo-raises-e4-5-million-to-accelerate-sustainable-ingredients-platform/", // include scheme
    date: "2025-09-23",
  },
   
  {
    title: "Paulig’s venture arm PINC joins £4 million investment in Scindo to accelerate sustainable ingredients",
    source: "Comunicaffe",
    url: "https://www.comunicaffe.com/pauligs-venture-arm-pinc-joins-4-million-investment-in-scindo-to-accelerate-sustainable-ingredients/", // include scheme
    date: "2025-09-23",
  },
   
  {
    title: "Paulig venture arm PINC invests into AI start-up Scindo",
    source: "Food manufacture",
    url: "https://www.foodmanufacture.co.uk/Article/2025/09/23/paulig-venture-arm-pinc-invests-into-ai-start-up-scindo/", // include scheme
    date: "2025-09-23",
  },

  {
    title: "Scindo Secures £4m for Enzyme Innovation",
    source: "Sustainable Business Magazine",
    url: "https://sustainablebusinessmagazine.net/featured/scindo-secures-4m-for-enzyme-innovation/", // include scheme
    date: "2025-09-23",
  },

   {
    title: "UK-based Scindo Raises €4.5 Million Funding",
    source: "Startup Rise",
    url: "https://startuprise.co.uk/uk-based-scindo-raises-e4-5-million-funding/", // include scheme
    date: "2025-09-23",
  },

   {
    title: "Scindo lands £4m in funding from Kadmos Capital and Clay Capital to develop enzyme platform for sustainable chemicals",
    source: "Soapbox",
    url: "https://www.soapbox.vc/feed/scindo-4m-equity", // include scheme
    date: "2025-09-23",
  },

     {
    title: "AI platform Scindo raises £4m led by Kadmos Capital and Clay Capital",
    source: "Startupmag",
    url: "https://www.startupmag.co.uk/funding/scindo-raised-4000000/", // include scheme
    date: "2025-09-23",
  },

     {
    title: "PINC investerar i brittiska Scindo vill utveckla hållbara ingredienser med AI",
    source: "Butikstrender",
    url: "https://www.butikstrender.se/inc-investerar-i-brittiska-scindo-vill-utveckla-hallbara-ingredienser-med-ai/", // include scheme
    date: "2025-09-23",
  },

      {
    title: "AI-enzymteknik revolutionerar hållbara ingredienser",
    source: "Finanstidning",
    url: "https://finanstidning.se/ai-enzymteknik-hallbara-ingredienser", // include scheme
    date: "2025-09-23",
  },

        {
    title: "The 200+ Startups Manufacturing the Future of Climate Tech",
    source: "HackSummit",
    url: "https://hacksummit.beehiiv.com/p/200-startups-manufacturing-future-climate-tech", // include scheme
    date: "2024-08-14",
  },
  
        {
    title: "HackTrends: Waste to Chemicals 20 startups and scaleups greening the chemical sector",
    source: "HackTrends",
    url: "https://reports.hacktrends.co/p/hacktrends-waste-to-chemicals", // include scheme
    date: "2024-06-19",
  },
  
       {
    title: "These 8 Material Science & Circular Tech Startups Are Innovating For A Plastic-Free World",
    source: "Green Queen",
    url: "https://www.greenqueen.com.hk/plastic-free-tech-startups/", // include scheme
    date: "2022-09-16",
  },

       {
    title: "A glimpse at sustainability-driven innovations in advanced materials",
    source: "Aera VC",
    url: "https://medium.com/advanced-m2/a-glimpse-at-sustainability-driven-innovations-in-advanced-materials-1e6ca8f55ef4", // include scheme
    date: "2021-10-20",
  },

      {
    title: "How 8 start-ups tackle plastic pollution",
    source: "Waste Management World",
    url: "https://waste-management-world.com/artikel/how-8-start-ups-tackle-plastic-pollution", // include scheme
    date: "2021-04-26",
  },

        {
    title: "Eight Start-ups Tackling Plastic Pollution Through Material Innovation and Circular Technologies",
    source: "Bioplastic News",
    url: "https://bioplasticsnews.com/2021/04/23/rethinking-materials-start-ups-tackling-plastic-pollution-material-innovation-circular-technologies/", // include scheme
    date: "2021-04-23",
  },
  
       {
    title: "Next-gen skincare, silk without spiders and pollution for lunch: Meet the biotech startups pitching at IndieBio’s Demo Day",
    source: "Techcrunch",
    url: "https://techcrunch.com/2020/10/27/next-gen-skincare-silk-without-spiders-and-pollution-for-lunch-meet-the-biotech-startups-pitching-at-indiebios-demo-day/", // include scheme
    date: "2020-10-27",
  },


  
  // add more here…
];

// ⬇️ Add these here (after the array)
export const mediaLinks = MEDIA_LINKS;
export default MEDIA_LINKS;
